import './App.css';
import { Routes, Route, BrowserRouter as Router } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import Home from './pages/Home.jsx';
import Blog from './pages/Blog.jsx';
import GoalsPlanner from './pages/GoalsPlanner.jsx';
import EmailReminder from './pages/EmailReminder.jsx';
import PiRunner from './pages/PiRunner.jsx';

function App() {
  return (
    <HelmetProvider>
      <Router>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/goals-planner" element={<GoalsPlanner />} />
          <Route path="/email-reminder" element={<EmailReminder />} />
          <Route path="/pi-runner" element={<PiRunner />} />
        </Routes>
      </Router>
    </HelmetProvider>
  );
}

export default App;
